<template>
  <div>
    <!-- Overlay (sibling, not child) -->
    <div v-if="isOpen" class="sidebar-overlay" :class="{ 'active': isOpen }" @click="closeSidebar"></div>

    <!-- Sidebar -->
    <aside class="app-sidebar" :class="{ 'active': isOpen }">
      <div class="sidebar-header">
        <h3>Menu</h3>
        <button @click="closeSidebar" class="sidebar-close" aria-label="Close menu">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <nav class="sidebar-menu">
        <a
          v-for="category in props.categories"
          :key="category.id"
          :href="categoryUrl(category)"
        >
          <i :class="category.icon || 'fas fa-tag'"></i>
          <span>{{ category.name }}</span>
        </a>
      </nav>
    </aside>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// Props from Laravel
const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  }
})

const isOpen = ref(false)

const categoryUrl = (category) => `/${category.slug}`

const closeSidebar = () => {
  isOpen.value = false
}

const toggleSidebar = () => {
  isOpen.value = !isOpen.value
}

onMounted(() => {
  window.addEventListener('toggle-sidebar', toggleSidebar)
})
</script>
